import { render, staticRenderFns } from "./AddNotifiedModal.vue?vue&type=template&id=6beb10b9"
import script from "./AddNotifiedModal.vue?vue&type=script&lang=js"
export * from "./AddNotifiedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports